import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {Modal } from 'react-bootstrap';
import './quickSharePopup.css';
import API from '../../../utils/API';
import userIcon from "../../../images/3.png";
import flagIcon from "../../../images/18.png";
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share';

interface ISharingOption {
  shareLink?: boolean; //to make the share symbol into a Neddie Button
  setShareLink?: (value: boolean) => void; //to make the share button light
  type?: 'profile' | 'wishlist' | 'marketplace'; // optional prop to show only specific share option
}

const QuickSharePopup: React.FC<ISharingOption> = ({ shareLink, setShareLink, type }) => {
  const reduxOrg = useSelector((state: any) => state.org);
  const [nonProfit, setNonProfit] = useState<any[]>([]);
   const [showSharingModal, setShowSharingModal] = useState(false);
   const [selectedSharingItem, setSelectedSharingItem] = useState<string | null>(null);
     const [selectedCampaign, setSelectedselectedCampaign] = useState<any>(null);

  useEffect(() => {
    API.getNpCampaigns(reduxOrg._id).then((result) => {
      console.log(result.data, 'non-profit');
      console.log(nonProfit, 'non-profit');
      setNonProfit(
        result.data.sort((a: any, b: any) => b.createdAt - a.createdAt)
      );
    });
  }, []);

    const getSharingProps = (id: string) => {
    if (id === 'profile') {
      return {
        componentHeaderText: 'Share your profile page',
        url: 'https://neddie.co/nonprofit/' + reduxOrg._id,
        postDescription: 'Check out the ' + reduxOrg.name + ' profile page on Neddie',
        twitterHashtags: ['Neddie', 'Nonprofits']
      };
    } else if (id === 'wishlist') {
      return {
        componentHeaderText: 'Share your wishlist',
        url: reduxOrg?.actionItems?.wishlist,
        postDescription: 'Check out the ' + reduxOrg.name + ' Wishlist ',
        twitterHashtags: ['Neddie', 'Nonprofits']
      };
    } else if (id === 'store') {
      return {
        componentHeaderText: 'Share your marketplace',
        url: reduxOrg?.actionItems?.marketplace,
        postDescription: 'Check out the ' + reduxOrg.name + ' Marketplace ',
        twitterHashtags: ['Neddie', 'Nonprofits']
      };
    } else if (id === 'fundraiser') {
      return {
        componentHeaderText: 'Share this Fundraiser',
        url: 'https://neddie.co/donation/' + reduxOrg._id + '/' + selectedCampaign.campaignId,
        postDescription: 'Check out the ' + selectedCampaign?.name + ' Fundraiser',
        twitterHashtags: ['Neddie', 'Nonprofits']
      };
    }
    return null;
  };

  return (
    <>
     <Modal
        show={shareLink}
        onHide={setShareLink}
        size="lg"
        className="social-share-modal"
        dialogClassName="modal-bottom"
      >
        <Modal.Header closeButton>
          <Modal.Title>Social Share Hubb</Modal.Title>
          
        </Modal.Header>
        <Modal.Body>
          <div className="social-share-grid">
            <div className="social-share-item" onClick={() => { setShowSharingModal(true); setSelectedSharingItem('profile'); }}>
              <div className="social-share-icon share-profile">
                <img style={{ width: "44px" }} src={userIcon} alt="profile" />
              </div>
              <small>Share Profile</small>
            </div>

            <div className="social-share-item" onClick={() => { setShowSharingModal(true); setSelectedSharingItem('wishlist'); }}>
              <div className="social-share-icon share-wishlist">
                <img style={{ width: "44px" }} src="/mobile-icon/7.png" alt="icon" />
              </div>
              <small>Share Wishlist</small>
            </div>

            <div className="social-share-item" onClick={() => { setShowSharingModal(true); setSelectedSharingItem('store'); }}>
              <div className="social-share-icon share-store">
                <img style={{ width: "44px" }} src="/mobile-icon/2.png" alt="icon" />
              </div>
              <small>Share Store</small>
            </div>

            {/* Dynamic fundraiser items from campaigns */}
            {nonProfit.length > 0 ? (
              <>
                {nonProfit.slice(0, 3).map((campaign, index) => {
                  return (
                    <div
                      key={campaign._id || campaign.id || index}
                      className="social-share-item"
                      onClick={() => {
                        setShowSharingModal(true);
                        setSelectedSharingItem('fundraiser');
                        setSelectedselectedCampaign(campaign)
                      }}
                    >
                      <div className="social-share-icon share-fundraiser">
                        <img style={{ width: "44px", height: '44px', objectFit: 'contain' }} src={flagIcon} alt="fundraiser" />
                      </div>
                      <small>{campaign.name || `Campaign ${index + 1}`}</small>
                    </div>
                  );
                })}
              </>
            ) : (
             null
            )}
          </div>
        </Modal.Body>
      </Modal>
    {/* <Modal centered show={shareLink} onHide={setShareLink} className='manage-share-popups'>
      <div className='manage-wish-wrap'>
        <span className='cancle-popup' onClick={handleSetWishList}>x</span>

        <div className='dashBoard-infocard-top-row'>
          <h2 className='dashboard-info-h2'>QUICK SHARE <img src={six} style={{ width: '22px', marginTop: '-5px' }} alt="" /></h2>
        </div>
        With Others
        <div className='dashboard-quick-link-box-container'>
          <div className="row" style={{width:'100%'}}>
            {(!type || type === 'profile') && <div className="col-lg-3 col-6">
              <div className='dashboard-quick-link-box one'>
                <span className='dashboard-link-box'>
                  <Image className='dashboard-link-icon' src={profile} />
                </span>
                <div className='dashboard-link-box-text'>
                  <span>Profile</span>
                </div>

                <SharingOptions
                  componentHeaderText={'Share your profile page'}
                  url={'https://neddie.co/nonprofit/' + reduxOrg._id}
                  postDescription={
                    'Check out the ' + reduxOrg.name + ' profile page on Neddie'
                  }
                  twitterHashtags={['Neddie', 'Nonprofits']}
                />
              </div>
            </div>}
            {(!type || type === 'wishlist') && <div className="col-lg-3 col-6">
              <div className='dashboard-quick-link-box two'>
                <span className='dashboard-link-box'>
                  <Image className='dashboard-link-icon ' src={four} />
                </span>
                <div className='dashboard-link-box-text'>
                  <span>Wishlist</span>
                </div>
                <SharingOptions
                  componentHeaderText={'Share your wishlist'}
                  url={reduxOrg?.actionItems?.wishlist}
                  postDescription={
                    'Check out the ' + reduxOrg.name + ' Wishlist '
                  }
                  twitterHashtags={['Neddie', 'Nonprofits']}
                />
              </div>
            </div>}
            {(!type || type === 'marketplace') && <div className="col-lg-3 col-6">
              <div className='dashboard-quick-link-box three'>
                <span className='dashboard-link-box'>
                  <Image className='dashboard-link-icon' src={three} />
                </span>
                <div className='dashboard-link-box-text'>
                  <span>Marketplace</span>
                </div>
                <SharingOptions
                  componentHeaderText={'Share your marketplace'}
                  url={reduxOrg?.actionItems?.marketplace}
                  postDescription={
                    'Check out the ' + reduxOrg.name + ' Marketplace '
                  }
                  twitterHashtags={['Neddie', 'Nonprofits']}
                />
              </div>
            </div>}
          {!type && nonProfit.map((item: any, index: any) => {
            return (
              <div className="col-lg-3 col-6">
              <div className='dashboard-quick-link-box four' key={index}>
                <span className='dashboard-link-box'>
                  <Image className='dashboard-link-icon' src={nine} />
                </span>
                <div className='dashboard-link-box-text'>
                  <span>{item?.name}</span>
                </div>
                <SharingOptions
                  componentHeaderText={'Help ' + item.name + ' by sharing this fundraiser'}
                  url={'https://www.neddie.co/donation/' + reduxOrg?._id + '/' + item?.id}
                  postDescription={
                    'Help ' + item?.id + ' by sharing or donating to this fundraiser!'
                  }
                  twitterHashtags={['NEDDIE', 'nonprofits', 'fundraiser']}
                />
              </div>
              </div>
            )
          })}
          </div>
        </div>
      </div>

    </Modal> */}
       <Modal
            show={showSharingModal}
            onHide={() => setShowSharingModal(false)}
            size="lg"
            className="manage-share-popups"
            dialogClassName="modal-bottom"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {selectedSharingItem === 'profile'
                  ? 'Share your profile page'
                  : selectedSharingItem === 'wishlist'
                    ? 'Share your wishlist'
                    : selectedSharingItem === 'fundraiser'
                      ? 'Share your fundraiser'
                      : 'Share your marketplace'}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="sharing-options-modal-body">
                <div className="sharing-grid">
                  <div className="share-item">
                    <FacebookShareButton
                      className="share-circle"
                      url={getSharingProps(selectedSharingItem!)?.url}
                      quote={getSharingProps(selectedSharingItem!)?.postDescription}
                      hashtag="NEDDIE"
                    >
                      <FacebookIcon size={40} round />
                    </FacebookShareButton>
                    <small>Facebook</small>
                  </div>
    
                  <div className="share-item">
                    <LinkedinShareButton
                      className="share-circle"
                      url={getSharingProps(selectedSharingItem!)?.url}
                      summary={getSharingProps(selectedSharingItem!)?.postDescription}
                    >
                      <LinkedinIcon size={40} round />
                    </LinkedinShareButton>
                    <small>LinkedIn</small>
                  </div>
    
                  <div className="share-item">
                    <TwitterShareButton
                      className="share-circle"
                      url={getSharingProps(selectedSharingItem!)?.url}
                      title={getSharingProps(selectedSharingItem!)?.postDescription}
                      hashtags={getSharingProps(selectedSharingItem!)?.twitterHashtags}
                    >
                      <div style={{ width: '40px', height: '40px', minWidth:'40px' , borderRadius: '50%', background: '#000000', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', fontSize: '18px' }}>X</div>
                    </TwitterShareButton>
                    <small>X</small>
                  </div>
    
                  <div className="share-item">
                    <EmailShareButton
                      className="share-circle"
                      url={getSharingProps(selectedSharingItem!)?.url}
                      subject={getSharingProps(selectedSharingItem!)?.postDescription}
                    >
                      <EmailIcon size={40} round />
                    </EmailShareButton>
                    <small>Email</small>
                  </div>
                  <div className="share-item">
                    <WhatsappShareButton className="share-circle" url={getSharingProps(selectedSharingItem!)?.url} title={getSharingProps(selectedSharingItem!)?.postDescription}>
                      <WhatsappIcon size={40} round />
                    </WhatsappShareButton>
                    <small>Whatsapp</small>
                  </div>
                </div>
                <div className="share-link-row">
                  <label>Page Link</label>
                  <div className="share-link-input">
                    <input
                      readOnly
                      value={getSharingProps(selectedSharingItem!)?.url || ''}
                      onFocus={(e) => e.currentTarget.select()}
                    />
                    <button
                      type="button"
                      className="copy-btn"
                      onClick={() => {
                        navigator.clipboard.writeText(getSharingProps(selectedSharingItem!)?.url || '');
                      }}
                    >
                      Copy
                    </button>
                  </div>
                </div>
    
                <div className="close-button-container">
                  <button className="btn btn-light" onClick={() => setShowSharingModal(false)}>Cancel</button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
    </>
  );
};

export default QuickSharePopup;
